(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.analytics.consent-modal'
  var templateUrl = require('./tpl/consent-modal.html')

  require('./scss/consent-modal.scss')
  require('dynamic-bind-html') // ಠ_ಠ

  require('angular')
    .module(MODULE_NAME, [
      'dynamicBindHtml',
      require('../../modal')
    ])
    .component('thismomentAnalyticsConsentModal', {
      bindings: {
        resolve: '<',
        close: '&'
      },
      templateUrl: templateUrl,
      controller: consentController
    })

  consentController.$inject = []
  function consentController () {
    var vm = this

    vm.$onInit = consentInit

    function consentInit () {
      vm.title = vm.resolve.options.title
      vm.description = vm.resolve.options.description
      vm.onApprove = onApprove
      vm.onReject = onReject

      function onApprove () {
        vm.resolve.options.resolvePromise()
        vm.close()
      }
      function onReject () {
        vm.resolve.options.rejectPromise()
        vm.close()
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/analytics/component/consent-modal.js